/**
To use React related functionality
*/
import React from 'react';
import TripWarning from './TripWarning';
import {IconPedestrian} from '../../Icons';

/**
* It is written in Diretion>>TripWarnings>>MaxWalkExceededWarning.
* The MaxWalkExceededWarning is a warning message that appears in Open Trip Planner when you try to create a trip that exceeds the maximum walking distance you have specified. This message is displayed when the total distance of the trip, as calculated by Open Trip Planner, is greater than the maximum walking distance you have set. 
* Function is used in Directions>>TripWarning>>Index.
* @param {Object} Props
* @return {HTMLElement} Warning Body
*/
const MaxWalkExceededWarning = props => {
    return (
        <TripWarning
            icon={<IconPedestrian />}
            screenReaderText='Alert: Trip exceeds max walking request.'
            summaryText='Some of your trips exceed your max walking request.'
            {...props}
        />
    );
};

export default MaxWalkExceededWarning;